import * as React from 'react';

import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';

import useStyles from './useStyles';
import FieldTextInput from '../../components/FieldTextInput';
import MaterialButton from '../../components/MaterialButton';

const AddClient: React.FC<any> = (props) => {
  const styles = useStyles(useTheme());

  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.sectionContainer}>
        <Field
          name="clientName"
          label={t('admin.createClient')}
          component={FieldTextInput}
          fullWidth
          required
        />
      </div>
      <div className={styles.buttonContainer}>
        <MaterialButton
          variant="outlined"
          disabled={props.pristine || props.invalid || props.submitting}
          onClick={props.handleSubmit}
          soft
          teal
        >
          Submit
        </MaterialButton>
      </div>
    </div>
  );
};

export default AddClient;
